<template>
  <div class="h-full">
    <TopBarBack class="fixed top-0 w-screen"
      :back-page="backPage">
      <template #leadingicon>
        <slot name="leadingicon" />
      </template>

      <template #headline>
        <slot name="headline" />
      </template>
    </TopBarBack>
    <div class="flex flex-1 flex-col h-screen relative">
      <main class="grow min-w-full overflow-y-scroll pt-topbar px-safe" :class="{
        'pb-footer': $slots.footer,
        'pb-safe': !$slots.footer,
        [bgColorClass]: true
      }">
        <slot />
      </main>

      <div v-if="$slots.footer"
        class="fixed bottom-0 h-20 w-full flex justify-between items-center px-safe pb-safe shadow-top-sm bg-background/80 backdrop-blur-xl">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import TopBarBack from '../components/TopBar/TopBarBack.vue';
import { RouteLocationNamedRaw } from 'vue-router';

const props = withDefaults(defineProps<{
  backPage?: RouteLocationNamedRaw;
  color?: BgColor;
}>(), {
  color: 'slate',
});

type BgColor = 'blue' | 'white' | 'slate';

const colors: Record<BgColor, string> = {
  blue: 'bg-blue-50',
  white: '',
  slate: ''
}

const bgColorClass = computed(() => colors[props.color] || colors.slate);

</script>